export const mapToDropdownOptions = (
  data: any[],
  labelKeys: string[],
  valueKey = 'id',
) => {
  if (!Array.isArray(data)) {
    return [];
  }
  return data.map(item => {
    const values = labelKeys.map(key => item?.[key]).filter(Boolean);
    const label: string =
      values.length === 0
        ? '-'
        : values.length === 1
        ? String(values[0])
        : values.map(String).join(' - ');
    return {
      value: item?.[valueKey],
      label,
    };
  });
};

export const getDropdownLabelText = (label: unknown): string | null => {
  const parts = Array.isArray(label) ? label : [label];
  const text = parts
    .filter(
      (part): part is string | number =>
        typeof part === 'string' || typeof part === 'number',
    )
    .map(String)
    .join(' ')
    .trim();

  return text || null;
};

export function hasAtLeastOneValidFieldValueInForm<T extends Object>(
  data: T,
): boolean {
  const hasValue = Object.values(data).some(value => value !== null);
  return hasValue;
}

export function debounce<T extends (...args: any[]) => any>(
  func: T,
  timeout = 300,
): T {
  let timer: NodeJS.Timeout | null;
  const debouncedFunc = (...args: Parameters<T>): void => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(null, args);
    }, timeout);
  };
  return debouncedFunc as T;
}

export function getFormattedAmount(amount: number | string) {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
  }).format(Number(amount));
}

export function formatNumber(input: number | string) {
  const num = Number(input);
  return num.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

/** Format amount for display without currency symbol (e.g. no ₹). Use in payment reminder tables. */
export function formatAmountNoSymbol(amount: number | string): string {
  const num = Number(amount);
  if (Number.isNaN(num)) return '-';
  return formatNumber(num);
}

export const arrayMove = <T>(
  arr: T[],
  fromIndex: number,
  toIndex: number,
): T[] => {
  const newArray = [...arr];
  const [movedItem] = newArray.splice(fromIndex, 1);
  newArray.splice(toIndex, 0, movedItem);
  return newArray;
};
